module.exports = __webpack_public_path__ + "static/Benz@2x.cb396475.png";